module.exports = __webpack_public_path__ + "img/bg.bd542173.png";